import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import SectionView from "../../../layout/section/SectionView";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import {Dispatch} from "redux";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import {removeAssetFromBillOfMaterials} from "../../../../store/action/billOfMaterials/billOfMaterials";
import {connect} from "react-redux";
import {BomItem} from "../../../../model/job/BomItems";

interface IComponentProps {
	/**
	 * On close button click.
	 */
	closeModal: () => void;
	/**
	 * Bill of materials id
	 */
	bomId: string;
	/**
	 * Asset selected to remove.
	 */
	selectedAsset: BomItem;
	/**
	 * Job id
	 */
	jobId: string;
}

interface DispatchProps {
	/**
	 */
	removeAssetFromBillOfMaterials: (bomId: string,
		assetId: string,
		jobId: string,
		onSuccess: OnSuccess,
		onFailure: OnFailure) => void
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & DispatchProps;

class RemoveAssetModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {
			isSubmitting: false
		};
		this.removeAsset = this.removeAsset.bind(this);
		this.getHeader = this.getHeader.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.closeModal} title={this.getHeader()}>
				<SectionView>
					This will also remove all materials associated with this asset.
				</SectionView>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.closeModal}
									label={"Cancel"}
									disabled={this.state.isSubmitting}/>
					<ButtonPrimary onClick={this.removeAsset}
								   label={"Remove"}
								   disabled={this.state.isSubmitting}
								   isLoading={this.state.isSubmitting}/>
				</FormButtonsView>
			</Modal>
		);
	}

	getHeader() {
		return (
			<div>Remove asset "<strong>{this.props.selectedAsset.name}</strong>"</div>
		);
	}

	removeAsset() {

		this.setState({isSubmitting: true}, () => {
			this.props.removeAssetFromBillOfMaterials(
				this.props.bomId,
				this.props.selectedAsset.id, this.props.jobId,
				this.props.closeModal,
				(error) => {
					this.setState({isSubmitting: false});
					notifyBugsnagAndShowToast(error, 'Remove an asset from order');
				});
		});
	}

}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		removeAssetFromBillOfMaterials: (bomId: string,
			assetId: string,
			jobId: string,
			onSuccess: OnSuccess,
			onFailure: OnFailure) => dispatch(
			removeAssetFromBillOfMaterials(bomId, assetId, jobId, onSuccess, onFailure)
		)
	}
}

export default connect(null, mapDispatchToProps)(RemoveAssetModal);